import React, { useState, useEffect, Component } from 'react'
import { useHistory, Link, withRouter } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { authFetch } from '../../../auth';

const CustomerDelete = (props) => {
    const history = useHistory();
    const initialState = () => {
        return (props)
    }

    const [state, setState] = useState(initialState);
    const [showModal, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        setState(props);
    }
    
    const handleRemoveCustomer = () => {
        
        authFetch(`https://fltbd.herokuapp.com/api/customers/delete/${props.customer_id}`, {
            method: 'DELETE',

        })
        
        const dataCopy = [...props.customers]
        const newList = dataCopy.filter(x => x.customer_id !== props.customer_id )
        props.updateCustomersList(newList)
        history.push('/customers')
    }



    return (
        <>
            <div>
                <Link>
                    <button className="btn btn-danger btn-uppercase mt-3 float-right" onClick={handleShow}>
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>

                        Delete Customer
                    </button>
                </Link>

                <Modal
                    show={showModal}
                    onHide={handleClose}
                    backdrop="static"
                    keyboard={false}
                    
                    
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Are you sure?</Modal.Title>
                    </Modal.Header>
                    <form>
                        <Modal.Body class="modal-body">
                            <div>Are you sure you want to delete this customer? All data from this customer will be lost.</div>
                            <br />
                            <div>If you aren't sure, you better ask somebody.</div>
                           


                        </Modal.Body>
                        <Modal.Footer>
                         <Button variant="primary" onClick={handleClose}>
                                Don't Delete
                            </Button>
                            <Button variant="danger" onClick={handleRemoveCustomer} >
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><line x1="4" y1="7" x2="20" y2="7" /><line x1="10" y1="11" x2="10" y2="17" /><line x1="14" y1="11" x2="14" y2="17" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>

                                Delete
                            </Button>
                            
                            
                        </Modal.Footer>
                    </form>
                </Modal>


            </div>
        </>
    )
}

export default CustomerDelete